// extracted by mini-css-extract-plugin
export var closeContainer = "styles-module--closeContainer--a4f57";
export var closeLine = "styles-module--closeLine--e5730";
export var first = "styles-module--first--900a9";
export var highlightedText = "styles-module--highlightedText--6fdcd";
export var modalBackground = "styles-module--modalBackground--f550c";
export var modalContent = "styles-module--modalContent--f51d9";
export var modalHeader = "styles-module--modalHeader--f4e04";
export var second = "styles-module--second--30291";